export interface IAddress {
  address1?: string;
  address2?: string;
  town?: string;
  county?: string;
  country?: string;
  postCode?: string;
}

export const emptyAddress: IAddress = {
  address1: '',
  address2: '',
  town: '',
  county: '',
  country: '',
  postCode: '',
};
